// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { useEffect } from 'react';
import { createCookieConsentConfig } from '../consent/cookieConsentConfig';

import 'vanilla-cookieconsent/dist/cookieconsent.css';

interface CookieConsentBannerProps {
  onConsentChange?: (analytics: boolean) => void;
}

export function CookieConsentBanner({ onConsentChange }: CookieConsentBannerProps) {
  useEffect(() => {
    let cleanup = false;

    const initConsent = async () => {
      const CookieConsent = await import('vanilla-cookieconsent');

      if (cleanup) return;

      const config = createCookieConsentConfig({
        onConsentChange: (accepted) => {
          onConsentChange?.(accepted);
        },
      });

      CookieConsent.run(config);
    };

    initConsent();

    return () => {
      cleanup = true;
    };
  }, [onConsentChange]);

  return null;
}
